import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-page-footer-controls",
    templateUrl: "./edit-page-footer-controls.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPageFooterControlsComponent {

}
